import { connect } from 'react-redux';
import ProductCard from './ProductCard';


let mapStateToProps = (state) => {
  return {
    productsData: state.productsPage.productsData
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const ProductCardContainer = connect(mapStateToProps, mapDispatchToProps)(ProductCard);

export default ProductCardContainer;